import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { formatarCampoInteiro, formatarNumero } from "../shared";

export default function HorarioPrevisao({ data, onPrint, tableRef }) {
  return (
    <>
      <div>
        <div className="p-card-title p-mt-4">Horário de Previsão</div>
        <Button className="p-m-1" icon="pi pi-print" onClick={onPrint} />
        <DataTable
          ref={tableRef}
          size="small"
          defaultSortOrder={1}
          tableStyle={{ fontSize: 18 }}
          value={data}
          filterDisplay="row"
        >
          <Column header="Tear" sortable field="tear" />
          <Column 
            header="Artigo" 
            filter 
            showFilterMenu={false} 
            filterPlaceholder="Filtrar..." 
            sortable 
            field="artigo" 
          />
          
          <Column
            header="Data Envio"
            sortable
            sortField="data_inicial"
            field="data_inicialf"
          />
          <Column
            header="Data Previsão"
            sortable
            sortField="data_final"
            field="data_finalf"
          />
          <Column
            header="Metros Tecido"
            field="metros_tecido"
            sortable
            body={formatarCampoInteiro}
          />
          <Column
            header="Metros Urdume"
            field="metros"
            sortable
            body={formatarCampoInteiro}
          />
          <Column
            header="Metros Previsto"
            sortable
            body={(rowData) => {
              const total =
                (parseInt(rowData.metros) + parseInt(rowData.metros_tecido)) *
              0.85;
              return formatarNumero(total);
            }}
          />
          <Column header="Turma" sortable field="turma" />
        </DataTable>
      </div>
    </>
  );
}